import Ajax from 'global/od/Ajax';

export const getShoppingLists = (data = {}) =>
	Ajax.get('/ajax/shopping-list/user-created/select', {
		data,
	});

export const addOrCreateList = (data = {}) =>
	Ajax({
		url: '/ajax/shopping-list/user-created/entries/add',
		method: 'POST',
		contentType: 'application/json',
		dataType: 'html',
		data,
	});
